import { render, staticRenderFns } from "./EmailStepSection.vue?vue&type=template&id=637afaf0"
import script from "./EmailStepSection.vue?vue&type=script&lang=js"
export * from "./EmailStepSection.vue?vue&type=script&lang=js"
import style0 from "./EmailStepSection.vue?vue&type=style&index=0&id=637afaf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports